import {
  CrossSellsDescription,
  CrossSellsList,
  CrossSellsTitle,
  CrossSellsWrapper,
  Wrapper,
} from '~/components/Restaurant/ReservableCrossSells/ReservableCrossSellsShards'
import { gt } from '~/locale'

import ReservableCrossSellItem, { ReservableCrossSell } from '../ReservableCrossSellItem/ReservableCrossSellItem'

type ReservableCrossSellsProps = {
  crossSells: ReservableCrossSell[]
}

export const ReservableCrossSells = ({ crossSells }: ReservableCrossSellsProps) => {
  if (!crossSells.length) return null

  return (
    <Wrapper>
      <CrossSellsWrapper>
        <CrossSellsTitle>{gt.tp('RestaurantPage', 'FREE with every menu!')}</CrossSellsTitle>
        <CrossSellsDescription>{gt.tp('RestaurantPage', 'In the next step choose gifts for the reservation')}</CrossSellsDescription>
      </CrossSellsWrapper>
      <CrossSellsList>{crossSells?.map(crossSell => <ReservableCrossSellItem key={crossSell.id} crossSell={crossSell} />)}</CrossSellsList>
    </Wrapper>
  )
}
